import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import Icon from 'components/atoms/Icon';
import { infoFill } from 'components/atoms/Icon/icons';
import FocusLock from 'components/utilities/FocusLock';
import Modal from 'components/utilities/Modal';
import Toggle from 'components/utilities/Toggle';
import Button, { LinkButton } from '../Button';
import * as styles from './AdvantageCard.scss';
import Heading, { H2 } from '../Heading';
import { translate } from 'utils/translate';

const AdvantageCardContent = ({ imageTitle, imageUrl, prefix, note }) => (
  <React.Fragment>
    <img src={imageUrl} alt={imageTitle} />
    <div style={{ paddingTop: '.75rem' }}>
      <H2 className={styles.heading}>{prefix}</H2>
      <span>{note}</span>
    </div>

    <Icon className={styles.icon} icon={infoFill} />
  </React.Fragment>
);

const AdvantageCard = props => {
  const { imageUrl, imageTitle, targetUrl, description, color } = props;
  const btnRef = useRef(null);
  if (!description)
    return (
      <div
        className={styles.advantageCard}
        style={{ backgroundColor: `${color}33` }}
        onMouseEnter={e => {
          e.currentTarget.style.backgroundColor = `${color}66`;
        }}
        onMouseLeave={e => {
          e.currentTarget.style.backgroundColor = `${color}33`;
        }}
      >
        <LinkButton className={styles.modalOpen} href={targetUrl}>
          <AdvantageCardContent {...props} />
        </LinkButton>
      </div>
    );
  return (
    <Toggle
      on={false}
      render={({ on, toggle, setOff }) => (
        <React.Fragment>
          <div
            className={styles.advantageCard}
            style={{ backgroundColor: `${color}33` }}
            onMouseEnter={e => {
              e.currentTarget.style.backgroundColor = `${color}66`;
            }}
            onMouseLeave={e => {
              e.currentTarget.style.backgroundColor = `${color}33`;
            }}
          >
            <LinkButton
              className={styles.modalOpen}
              onClick={() => {
                toggle();
                setTimeout(() => {
                  if (btnRef.current) btnRef.current.focus();
                }, 100);
              }}
            >
              <AdvantageCardContent {...props} />
            </LinkButton>
          </div>
          {on && (
            <FocusLock>
              <Modal
                light
                maxWidth={400}
                ref={btnRef}
                onClose={setOff}
                shadow
                className={styles.modal}
              >
                <Modal.Body
                  className={styles.modalBody}
                  style={{ backgroundColor: `${color}66` }}
                >
                  <div>
                    <img src={imageUrl} alt={imageTitle} />
                    <p>{description}</p>
                  </div>
                  <Button href={targetUrl} className={styles.readmore}>
                    {translate('/product/advantageCard/readMore')}
                  </Button>
                </Modal.Body>
              </Modal>
            </FocusLock>
          )}
        </React.Fragment>
      )}
    />
  );
};
AdvantageCard.displayName = 'AdvantageCard';
AdvantageCard.propTypes = {
  imageUrl: PropTypes.string.isRequired,
  imageTitle: PropTypes.string.isRequired,
  prefix: PropTypes.string.isRequired,
  targetUrl: PropTypes.string.isRequired,
  note: PropTypes.string,
  color: PropTypes.string,
  description: PropTypes.string,
};

export default AdvantageCard;
